/**
 * @flow
 * @relayHash a4f31e88a518e2b4acc5cc36402187e9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type pdpSharedNotificationTradeMicroGoalConfigQueryVariables = {|
  itemId?: ?string,
  userId?: ?string,
  buyerId?: ?$ReadOnlyArray<?string>,
|};
export type pdpSharedNotificationTradeMicroGoalConfigQueryResponse = {|
  +viewer: ?{|
    +transactions: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +checkoutDate: ?string
        |}
      |}>
    |},
    +conversationsSolr: ?{|
      +totalResults: ?number
    |},
    +item: ?{|
      +canBuyerMakeOffer: ?boolean,
      +displayInfo: ?{|
        +ctas: ?{|
          +showRequestOnApproval: ?boolean,
          +showHoldRequest: ?boolean,
        |}
      |},
    |},
  |}
|};
export type pdpSharedNotificationTradeMicroGoalConfigQuery = {|
  variables: pdpSharedNotificationTradeMicroGoalConfigQueryVariables,
  response: pdpSharedNotificationTradeMicroGoalConfigQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "buyerId",
    "type": "[String]",
    "defaultValue": ([]/*: any*/)
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "buyerId",
    "variableName": "buyerId",
    "type": "[String]"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1,
    "type": "Int"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "checkoutDate desc",
    "type": "String"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "checkoutDate",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId",
  "type": "String"
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "conversationsSolr",
  "storageKey": null,
  "args": [
    (v3/*: any*/),
    {
      "kind": "Variable",
      "name": "itemId",
      "variableName": "itemId",
      "type": "String"
    }
  ],
  "concreteType": "ConversationsSolrConnection",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalResults",
      "args": null,
      "storageKey": null
    }
  ]
},
v5 = [
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemId",
    "type": "String!"
  }
],
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "canBuyerMakeOffer",
  "args": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "displayInfo",
  "storageKey": null,
  "args": [
    (v3/*: any*/),
    {
      "kind": "Literal",
      "name": "page",
      "value": "pdp",
      "type": "PageDisplayEnum"
    }
  ],
  "concreteType": "ItemDisplayInfo",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "ctas",
      "storageKey": null,
      "args": null,
      "concreteType": "CTADisplay",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showRequestOnApproval",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showHoldRequest",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "pdpSharedNotificationTradeMicroGoalConfigQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "transactions",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "TransactionConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TransactionEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Transaction",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v5/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "pdpSharedNotificationTradeMicroGoalConfigQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "transactions",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "TransactionConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TransactionEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Transaction",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v5/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ]
          },
          (v8/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "pdpSharedNotificationTradeMicroGoalConfigQuery",
    "id": "app-buyer-finding/222.0.0-2019-06-25T14:09:44.528Z/pdpSharedNotificationTradeMicroGoalConfigQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '31fa8718c29fd3d7b86d69cdf8100d9c';
module.exports = node;
